// ── src/data/marquee.ts ───────────────────────────────────────
import { TechItem } from '../types';

export const techItems: TechItem[] = [
  { label: 'Computer Vision' }, { label: 'Deep Learning' },
  { label: 'Object Detection' }, { label: 'NLP' },
  { label: 'Power BI' }, { label: 'TensorFlow' },
  { label: 'PyTorch' }, { label: 'MLOps' },
  { label: 'Data Analytics' }, { label: 'Azure AI' },
  { label: 'AWS SageMaker' }, { label: 'Edge AI' },
];
